<script>
import { useContainerFidelite } from "@/containers/mixin/fidelite.mixin";
import LazyImage from "@/components/atoms/lazy-image";
import Button from "@/components/atoms/button";

import carteMastercard from "@/assets/images/carte-mastercard-3.png";
import carteMalin from "@/assets/images/carte-malin-4.png";

export default {
  name: "FideliteMerchCards",
  components: {
    LazyImage,
    Button
  },
  setup() {
    const { setPopinAjoutCarte } = useContainerFidelite();
    return {
      setPopinAjoutCarte,
      carteMastercard,
      carteMalin,
    };
  },
  props: {
    card: {
      type: String,
      required: false,
      default: 'malin'
    }
  },
  methods: {
    buttonClick() {
      if (this.card === 'malin') {
        this.$router.replace('/creation-carte-fidelite')
      } else {
        this.setPopinAjoutCarte()
      }
    }
  }
};
</script>
<template>
  <div class="c-fidelite-merch-cards">
    <LazyImage
      :src="card === 'malin' ? carteMalin : carteMastercard"
      width="104"
      alt=""
      class="u-mb-xs"
    />
    <p class="u-font-secondary u-font-20 u-font-700 u-mb-xs">
      {{ card === 'malin' ? "Carte Malin" : "Carte cora Cpay Mastercard" }}
    </p>
    <p class="u-mb-sm">
      {{ card === 'malin' ? "Profitez des avantages de la carte de fidélité" : "Bénéficiez des offres et services exclusifs de la carte de crédit cora" }}
    </p>
    <Button
      size="sm"
      radius="full"
      variant="primary"
      class="u-mt-auto"
      @click="buttonClick"
    >
      {{ card === 'malin' ? "Je crée ma carte" : "J'enregistre ma carte" }}
    </Button>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/styles/components/fidelite-merch-cards.scss";
</style>
